import React, { useState } from 'react';

interface SegmentProps {
  items: string[]; // 每个 segment 的文本
  height?: number; // 高度，可选，默认 40
  onChange?: (index: number) => void; // 选中回调
  initialIndex?: number; // 默认选中项
}

const Segment: React.FC<SegmentProps> = ({
  items,
  height = 40,
  onChange,
  initialIndex = 0,
}) => {
  const [selected, setSelected] = useState(initialIndex);

  const handleClick = (index: number) => {
    setSelected(index);
    onChange?.(index);
  };

  return (
    <div
      style={{
        display: 'flex',
        width: '100%',
        height,
        borderRadius: height / 2,
        backgroundColor: 'rgba(255, 255, 255, 0.06)',
        overflow: 'hidden',
      }}
    >
      {items.map((item, index) => {
        const isActive = index === selected;
        return (
          <div
            key={index}
            onClick={() => handleClick(index)}
            style={{
              flex: 1,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              cursor: 'pointer',
              position: 'relative',
              zIndex: 1,
              transition: 'color 0.3s',
              color: isActive ? '#fff' : '#fff',
            }}
          >
            {item}
            {isActive && (
              <div
                style={{
                  position: 'absolute',
                  top: 0,
                  left: 0,
                  width: '100%',
                  height: '100%',
                  backgroundColor: '#007aff', // iOS 蓝色
                  borderRadius: height / 2,
                  transition: 'all 0.3s',
                  zIndex: -1,
                }}
              />
            )}
          </div>
        );
      })}
    </div>
  );
};

export default Segment;
